<template>
  <div>
    <DataTable :headers="headers" :path="path" :filter-path="filterPath" actionButtonsName="EventoActionButtons"
               :properties="properties" toolbar toolbar-title="Eventos" :filter="isClubRole"
               slot-name="second-last-column" search-text="Buscar por evento o descripción">
      <template slot="second-last-column" slot-scope="props" v-if="isSafRole">
        <template v-if="eventCanceled(props.item)">
          <td colspan="3" class="text-xs-center table-row-no-contracts custom-font-regular" :key="'row'">Evento cancelado</td>
        </template>
        <template v-else>
          <td class="text-xs-center table-row" :key="'row-1'">
            <v-chip small text-color="white" color="green lighten-2">{{ props.item.going }}</v-chip>
          </td>
          <td class="text-xs-center table-row" :key="'row-2'">
            <v-chip small text-color="white" color="red lighten-1">{{ props.item.notGoing }}</v-chip>
          </td>
          <td class="text-xs-center table-row" :key="'row-3'">
            <v-chip small text-color="grey darken-2" color="yellow">{{ props.item.unanswered }}</v-chip>
          </td>
        </template>
      </template>
    </DataTable>
    <v-btn v-if="canCreate" app dark fixed fab bottom right class="add-button" @click="newEvento">
      <v-icon>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DataTable from '../../../common/ui/DataTable'

export default {
  components: {
    DataTable
  },

  data () {
    return {
      properties: ['fecha', 'title', 'ubicacion'],
      path: 'events',
      filterPath: 'filters/events'
    }
  },

  computed: {
    ...mapGetters(['isSafRole', 'isClubRole']),
    canCreate () {
      return this.$store.state.permissions.canAddEventos
    },
    headers () {
      let headers = [
        { text: 'Horario', align: 'left', value: 'horario' },
        { text: 'Evento', value: 'title' },
        { text: 'Ubicación', sortable: false, value: 'ubicacion' }
      ]
      if (this.$store.getters.isSafRole) {
        headers.push({ text: 'Asistirán', value: 'going', sortable: false })
        headers.push({ text: 'No asistirán', value: 'not_going', sortable: false })
        headers.push({ text: 'A confirmar', value: 'unanswered', sortable: false })
      } else {
        headers.push({ text: 'Asistencia', sortable: false, value: 'going', visible: false, filterField: true })
      }
      headers.push({ text: 'Detalle', align: 'right', sortable: false })
      return headers
    }
  },

  methods: {
    newEvento () {
      this.$router.push({ name: 'nuevoEvento' })
    },
    eventCanceled (item) {
      return item.status === 0
    }
  }
}
</script>

<style scoped>
  .table-row {
    background-color: white;
    border-bottom: 1px solid #959ba6;
  }
  .table-row-no-contracts {
    background-color: #d0caca;
    border-bottom: 1px solid #959ba6;
  }
</style>
